import { Box, Grid2, Typography, useTheme } from "@mui/material";
import Icon from "../../../../Icon/Icon";
import { RichTextEditor } from "../../../../MainComponents/RichTextEditor/RichTextEditor";

export const InvestigationBlockInfo = ({
  label,
  labelColor,
  icon,
  iconColor,
  text = "",
  size = { xs: 12, lg: 6 },
  underline = true,
  richTextEditor = false,
  textEmpty = "",
  sx = {},
}) => {
  const theme = useTheme();
  const color = labelColor ? labelColor : theme.palette.secondary.main;
  return (
    <Grid2 size={size} sx={{ ...sx }}>
      {text || textEmpty ? (
        <>
          <Typography fontSize={12} fontWeight={600} color={color}>
            {label}
          </Typography>

          {richTextEditor ? (
            <Box
              borderBottom={
                underline ? `1px solid ${theme.palette.blueGray200.main}` : ""
              }
            >
              <RichTextEditor value={text || textEmpty} justView={true} />
            </Box>
          ) : (
            <Typography
              fontSize={16}
              component="div"
              borderBottom={
                underline ? `1px solid ${theme.palette.blueGray200.main}` : ""
              }
            >
              {icon && (
                <Icon
                  name={icon}
                  style={{ marginRight: 10 }}
                  color={iconColor ? iconColor : theme.palette.blueGray100.main}
                />
              )}
              {text || textEmpty}
            </Typography>
          )}
        </>
      ) : (
        <Typography
          fontSize={16}
          fontWeight={600}
          color={theme.palette.blueGray200.main}
          borderBottom={
            underline ? `1px solid ${theme.palette.blueGray200.main}` : ""
          }
        >
          {label}
        </Typography>
      )}
    </Grid2>
  );
};
